(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var nodes = (root || document).querySelectorAll('[data-about-image].about-image--reveal:not(.is-visible)');
      if (!nodes.length) return;
      if (!('IntersectionObserver' in window)) {
        nodes.forEach(function (n) { n.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      nodes.forEach(function (n) { io.observe(n); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var s = e.target.closest('[data-about-image]');
      if (s) s.classList.add('is-visible');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.bpReady) return;
      root.dataset.bpReady = 'true';

      // Sort: navigate with the new sort_by, keeping filters and the tag path.
      root.querySelector('[data-bp-sort]')?.addEventListener('change', (event) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });

      // Filter drawer.
      const dialog = root.querySelector('.bp-filters');
      root.querySelector('[data-bp-filter-open]')?.addEventListener('click', () => dialog?.showModal());
      root.querySelector('[data-bp-filter-close]')?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      // Bring the active pill into view when the tab strip overflows (mobile).
      const list = root.querySelector('.bp-tabs__list');
      const active = list?.querySelector('.is-active');
      if (list && active && list.scrollWidth > list.clientWidth) {
        const item = active.parentElement;
        list.scrollLeft = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
      }
    };

    document.querySelectorAll('.bp-collection').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('.bp-collection').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  // Bring the active tag pill into view when the tag strip overflows (mobile).
  document.querySelectorAll('.blog-tag-filter__list').forEach((list) => {
    const active = list.querySelector('.blog-tag-filter__link.is-active');
    if (!active || list.scrollWidth <= list.clientWidth) return;
    const item = active.parentElement;
    list.scrollLeft = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const subscribe = (key, list, source, email) =>
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: { data: { type: 'profile', attributes: { email } } },
            },
            relationships: { list: { data: { type: 'list', id: list } } },
          },
        }),
      }).then((res) => {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
      });

    const init = (root) => {
      if (root.dataset.newsletterReady) return;
      root.dataset.newsletterReady = 'true';

      const form = root.querySelector('.newsletter-signup__form');
      const input = form?.querySelector('input[type="email"]');
      const button = form?.querySelector('button[type="submit"]');
      const error = form?.querySelector('.newsletter-signup__error');
      const modal = root.querySelector('[data-newsletter-modal]');
      const { klaviyoKey: key, klaviyoList: list, klaviyoSource: source } = root.dataset;

      const showModal = () => {
        if (modal && typeof modal.showModal === 'function' && !modal.open) modal.showModal();
      };
      const setError = (message) => {
        if (!error) return;
        error.textContent = message;
        error.hidden = !message;
        input?.setAttribute('aria-invalid', message ? 'true' : 'false');
      };

      modal?.querySelectorAll('[data-newsletter-close]').forEach((btn) =>
        btn.addEventListener('click', () => modal.close())
      );
      modal?.addEventListener('click', (event) => {
        if (event.target === modal) modal.close();
      });
      if (modal?.hasAttribute('data-newsletter-open')) {
        showModal();
        // Shopify's fallback post lands on ?customer_posted=true; drop it so a refresh
        // doesn't reopen the modal.
        const url = new URL(window.location.href);
        if (url.searchParams.has('customer_posted')) {
          url.searchParams.delete('customer_posted');
          url.hash = '';
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }

      // No Klaviyo settings: leave the Shopify customer form to submit normally.
      if (!form || !input || !key || !list) return;

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const email = input.value.trim();
        if (!EMAIL_RE.test(email)) {
          setError('Please enter a valid email address.');
          input.focus();
          return;
        }
        setError('');
        button.disabled = true;
        subscribe(key, list, source || 'Newsletter Signup', email)
          .then(() => {
            form.reset();
            showModal();
          })
          .catch(() => setError('Something went wrong. Please try again.'))
          .finally(() => {
            button.disabled = false;
          });
      });
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-newsletter]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.sciReady) return;
      root.dataset.sciReady = 'true';

      const tabs = [...root.querySelectorAll('.sci-tabs__tab')];
      const panels = [...root.querySelectorAll('.sci-panel')];
      if (!tabs.length) return;

      const select = (key, { focus = false, updateHash = false } = {}) => {
        const tab = tabs.find((t) => t.dataset.sciKey === key) || tabs[0];
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach((p) => {
          p.hidden = p.id !== tab.getAttribute('aria-controls');
        });
        if (focus) tab.focus();
        if (updateHash) history.replaceState(null, '', '#' + tab.dataset.sciKey);
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab.dataset.sciKey, { updateHash: true }));
        tab.addEventListener('keydown', (event) => {
          const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (!step) return;
          event.preventDefault();
          const next = tabs[(i + step + tabs.length) % tabs.length];
          select(next.dataset.sciKey, { focus: true, updateHash: true });
        });
      });

      const fromHash = decodeURIComponent(window.location.hash.slice(1));
      if (fromHash && tabs.some((t) => t.dataset.sciKey === fromHash)) select(fromHash);
      window.addEventListener('hashchange', () => select(decodeURIComponent(window.location.hash.slice(1))));
    };

    document.querySelectorAll('[data-sci-tabs]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-sci-tabs]').forEach(init);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const tab = document.getElementById('SciTab-' + event.detail.blockId);
      tab?.click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
